import type { TSelector } from "../../i18n/types";
import type { ProgramEngine } from "../../zodios/apiDefinitions/api/programs";

export const ENGINES: Partial<Record<ProgramEngine, { title: TSelector }>> = {
  bidding: {
    title: ($) => $.programs["Bidding Program"],
  },
  budget: {
    title: ($) => $.programs["Campaign Program"],
  },
  pricing: {
    title: ($) => $.programs["Pricing Program"],
  },
  lineitem_bidding: {
    title: ($) => $.programs["Line Item Bidding Program"],
  },
  tagging: {
    title: ($) => $.programs["Tagging Program"],
  },
};
